import * as React from 'react';
import { alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import DeleteIcon from '@mui/icons-material/Delete';
import FilterListIcon from '@mui/icons-material/FilterList';
import { visuallyHidden } from '@mui/utils';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/styles": { alpha }, "@mui/material/Box": Box, "@mui/material/Table": Table, "@mui/material/TableBody": TableBody, "@mui/material/TableCell": TableCell, "@mui/material/TableContainer": TableContainer, "@mui/material/TableHead": TableHead, "@mui/material/TablePagination": TablePagination, "@mui/material/TableRow": TableRow, "@mui/material/TableSortLabel": TableSortLabel, "@mui/material/Toolbar": Toolbar, "@mui/material/Typography": Typography, "@mui/material/Paper": Paper, "@mui/material/Checkbox": Checkbox, "@mui/material/IconButton": IconButton, "@mui/material/Tooltip": Tooltip, "@mui/material/FormControlLabel": FormControlLabel, "@mui/material/Switch": Switch, "@mui/icons-material/Delete": DeleteIcon, "@mui/icons-material/FilterList": FilterListIcon, "@mui/utils": { visuallyHidden } } } });
export default ClientProvider;
